import type { CSSProperties } from 'react';
import { Alert, Link } from '@mokoboko/components';

export type RestrictionAction = { label: string; onClick: () => void };

// A one-time product the customer already bought: the reason, and the rule
// under it.
export const BOUGHT_BEFORE = {
  'class-pack': {
    reason: "You've bought this class pack before",
    detail: 'This pack can only be bought once.',
  },
  subscription: {
    reason: "You've bought this membership before",
    detail: 'This membership can only be bought once.',
  },
};

// The alert's own tint, hover included: Link hovers to --link-hover.
const TINTED_LINK = {
  '--link-hover': 'var(--alert-tint)',
  '--link-icon-hover': 'var(--alert-tint)',
} as CSSProperties;

export const AlertLink = ({ label, onClick }: RestrictionAction) => (
  <Link
    size="sm"
    onClick={onClick}
    className="!text-[color:var(--alert-tint)]"
    style={TINTED_LINK}
  >
    {label}
  </Link>
);

// Why a product can't be bought, with the way out beside it. The reason is a
// title over a detail or alone, and regular beside a lone link, which is bold
// and would blend into it.
export const RestrictionAlert = ({
  reason,
  detail,
  action,
  className,
}: {
  reason: string;
  detail?: string | null;
  action?: RestrictionAction;
  className?: string;
}) => {
  const asTitle = !!detail || !action;

  return (
    <Alert
      variant="warning"
      size="sm"
      actionsPlacement="end"
      title={asTitle ? reason : undefined}
      className={className}
      actions={action && <AlertLink {...action} />}
    >
      {asTitle ? detail : reason}
    </Alert>
  );
};
